import { animate, state, style, transition, trigger } from '@angular/animations';
import {
    AfterViewInit,
    Component,
    DestroyRef,
    ElementRef,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgForm } from '@angular/forms';
import { AuthService } from '@app/services/auth.service';
import { getHelpCentreArticle } from '@app/types/translatable.type';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent } from 'rxjs';

@Component({
    selector: 'app-form-setup-admin-welcome',
    templateUrl: './setup-admin-welcome.form.html',
    styleUrls: ['./setup-admin-welcome.style.scss'],
    animations: [
        trigger('fadeEffect', [
            state('no-fade', style({ opacity: 0 })),
            state('fade', style({ opacity: 1 })),
            transition('no-fade => fade', [animate('300ms ease-in-out')]),
            transition('fade => no-fade', [animate('300ms ease-in-out')]),
        ]),
    ],
})
export class SetupAdminWelcomeForm implements AfterViewInit, OnInit {
    @ViewChild('scrollableContent', { static: false }) scrollableContent: ElementRef;
    @ViewChild('form', { static: true }) form: NgForm;
    @Input() formData: any = {};
    @Output() valid: EventEmitter<any> = new EventEmitter<any>();

    fadeState = 'fade';

    URLS = {
        en_CA: {
            termsOfServiceUrl: 'https://employmenthero.com/en-ca/legals/terms-conditions/',
            privacyPolicyUrl: 'https://employmenthero.com/en-ca/legals/privacy-policy/',
            serviceRequestFeesUrl: getHelpCentreArticle('6344776076567', 'en_CA'),
        },
        fr_CA: {
            termsOfServiceUrl: 'https://employmenthero.com/fr-ca/legals/terms-conditions/',
            privacyPolicyUrl: 'https://employmenthero.com/fr-ca/legals/privacy-policy/',
            serviceRequestFeesUrl: getHelpCentreArticle('6344776076567', 'fr_CA'),
        },
    }[this.translateService.currentLang];

    private destroyRef = inject(DestroyRef);

    constructor(
        public auth: AuthService,
        private translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this.form.statusChanges?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.valid.emit({ valid: this.form.valid, data: this.formData });
        });
    }

    ngAfterViewInit(): void {
        fromEvent(this.scrollableContent.nativeElement, 'scroll')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.getFadeState());
    }

    getFadeState(): void {
        const element = this.scrollableContent.nativeElement;
        const isAtBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 1;

        this.fadeState = isAtBottom ? 'no-fade' : 'fade';
    }
}
